import {
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockTextInput,
  EditBlockNumericInput,
  EditBlockSliderInput,
  EditBlockSwitch,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'

export default {
  name: 'HeadlineEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
    'edit-block-switch': EditBlockSwitch,
  },
  data() {
    return {}
  },
  computed: {
    headlineText: {
      get() {
        return this.component.content.text
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['text'],
          data: value,
        })
      },
    },
    headlineFontFamily: {
      get() {
        return this.component.styling.fontFamily
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontFamily'],
          data: value,
        })
      },
    },
    headlineFontColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    headlineFontSize: {
      get() {
        return this.component.styling.fontSize
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontSize'],
          data: value,
        })
      },
    },
    headlineFontWeight: {
      get() {
        return this.component.styling.fontWeight === 'bold'
      },
      set(value) {
        const fontWeight = value ? 'bold' : 'normal'

        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontWeight'],
          data: fontWeight,
        })
      },
    },
    headlineTextAlign: {
      get() {
        return this.component.styling.textAlign
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['textAlign'],
          data: value,
        })
      },
    },
  },
}
